import { EDIT_LISTING_NEIGHBOURHOOD,
         CLOSE_LISTING_NEIGHBOURHOOD,
         PENDING_SUBMIT_LISTING_NEIGHBOURHOOD,
         COMPLETE_SUBMIT_LISTING_NEIGHBOURHOOD,
         FAILED_SUBMIT_LISTING_NEIGHBOURHOOD
    } from "./mlTypes"


const initialState = {
    pendingsubmit: false,
    failedsubmit: false,
    completesubmit: false,
    propertyneighbourhoodediting: false
}


const mlListingNeighbourhood = (state = initialState, action) => {
    switch (action.type) {
        case EDIT_LISTING_NEIGHBOURHOOD: return {
            ...state,
            pendingsubmit: false,
            failedsubmit: false,
            completesubmit: false,
            propertyneighbourhoodediting: true
        }

        case CLOSE_LISTING_NEIGHBOURHOOD: return {
            ...state,
            pendingsubmit: false,
            failedsubmit: false,
            completesubmit: false,
            propertyneighbourhoodediting: false
        }

        case PENDING_SUBMIT_LISTING_NEIGHBOURHOOD: return {
            ...state,
            pendingsubmit: true,
            failedsubmit: false,
            completesubmit: false
        }

        case COMPLETE_SUBMIT_LISTING_NEIGHBOURHOOD: return {
            ...state,
            pendingsubmit: false,
            failedsubmit: false,
            completesubmit: true
        }
        
        case FAILED_SUBMIT_LISTING_NEIGHBOURHOOD: return {
            ...state,
            pendingsubmit: false,
            failedsubmit: true,
            completesubmit: true
        }
    
        default: return state
    }
}

export default mlListingNeighbourhood